import * as React from 'react';
import {
    useSelector,
    useDispatch
} from 'react-redux';
import {  useState } from "react";
import {
    Props,
} from 'one-ui';
import { useCtx } from 'one-ui-provider';
import Phone from '@2fd/ant-design-icons/lib/Phone';
import PhoneOff from '@2fd/ant-design-icons/lib/PhoneOff';
import Modal from 'antd/lib/modal';
import Button from 'antd/lib/button';


export interface FinessePhonePluginProps extends Props {
    label?: string
    phone?: string;
    makecall?: any;
    type?: string;
}
export const FinessePhonePlugin = ({
    phone,
    label,
    makecall,
    type,
}: FinessePhonePluginProps): JSX.Element => {
    const dispatch = useDispatch();
    const userstate = useSelector((state: any) => (state.userstate));
    const  interaction  = useSelector((state: any) => (
        state.five9Interaction
      ));
      const [appmodel, setAppmodel] = useState(false);
      const [title, setTitle] = useState("");


    const { settings: { compatible: { contact_center_type } }, } = useCtx();

    let phoneactive: any;
    //default UI
    let ui = (
        <>
        {phoneactive ? phoneactive : ""}{phone}
         </>
    )
    // check for gadget
    if (contact_center_type && contact_center_type === 'five9') {
        let crmApi = window.Five9.CrmSdk.crmApi();
        ui = (
            <>
                <a onClick={() => {
                            let clickToDialNumber = phone.replace(/[^a-zA-Z0-9]/g, '');
                            crmApi.click2dial({click2DialData: { clickToDialNumber }, screenpopC2DSearch: true})
                            let interactionId = interaction?.interactionId;
                            if(interactionId?.length == 0){
                                dispatch({
                                    type: "store-five9-clicktodial",
                                    payload: {
                                        clicktodial: true,
                                        type: type
                                    }
                                })
                            }
                }} >
                 
                    
                    {phone && <Phone style={{marginLeft: '5px'}}/>}{phone}
                </a>
            </>
        )
    }
    else if (contact_center_type && contact_center_type === 'ringcentral') {
        ui = (
            <>
                <a onClick={() => {
                         setTitle(`Would you like to make an Outbound Call from RingCentral ? `)
                         setAppmodel(true);
                }} >
                      
                    
                    {phone && <Phone style={{marginLeft: '5px'}}/>}{phone}
                </a>
            </>
        )
    } 

    else {
        if (makecall && phone?.length > 0) {
            let agentstate = userstate?.state;
            if (agentstate && ( agentstate === "NOT_READY")) {
                phoneactive = (<Phone />)
                ui = (
                        <a onClick={() => {
                            let phonemodified = phone.replace(/[^a-zA-Z0-9]/g, '');
                                makecall.dial(phonemodified)
                        }} >
                            {phoneactive ? phoneactive : ""}{phone}
                        </a>
                )
            } else {
                phoneactive = (<PhoneOff />);
                ui = (
                 <>
                    {phoneactive ? phoneactive : ""}{phone}
                </>
                )
            }
    
        }
    }
    
   const handleConfirm = (phone:any)=>{
     
    if(phone.length>=10){
    document.querySelector("#rc-widget-adapter-frame").contentWindow.postMessage({
        type: 'rc-adapter-new-call',
        phoneNumber: `+1${phone}`,
        toCall: true,
      }, 'rc.pacqa.patient-assist.agenta-cloud.com.*')
      dispatch({
        type: "one-state-ring-central/click-to-call",
        payload: {
            phoneNumber:phone,
            clicktocall:true
        }
    })
    sessionStorage.setItem("clickTocall","true")
    setAppmodel(false);
}
else{
setTitle('select valid no.')
}
   }
   const handleAPPCancel = ()=>{
    setAppmodel(false);
   }

  
    return (
        <>
         <div className="values__value" >
            <b>
                {label}:
            </b>
            &nbsp; {ui}
            </div>
            <Modal
   title={title}
   width={508}
   visible={appmodel ===true}
   footer={null}
   centered
   closable={true}
   onCancel={handleAPPCancel}
   wrapClassName="custom-modal-wrap"
   destroyOnClose
   >
                    <div className="ant-modal-actions">
                    <Button key="submit" type="default"  onClick={() => handleAPPCancel()}>
           Cancel
       </Button>
       <Button key="submit" type="primary"  onClick={() => handleConfirm(phone)}>
           Confirm 
       </Button>
       </div>
       </Modal>
        </>
    );
}
